module.exports = __webpack_public_path__ + "static/media/Pizza.75037aff.svg";